import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "@mui/material";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { artifactManagementData } from "../constants";
import {
  AddMoreButton,
  Body,
  CardWrapper,
  Container,
  HeaderBox,
  HeaderTitle,
} from "../Components/curatorApprovalStyle";
import BackToFunction from "../Components/BackToFunction";
import ContentDetails from "../Components/ContentDetails";
import CropType from "../Components/CropType";
import Approval from "../Components/Approval";
import SummarySection from "../Components/SummarySection";
import PlusIcon from "../Components/PlusIcon";
import ArtifactManagement from "../Components/ArtifactManagement";
import { setSelectedCuratorPage } from "../../../slices/curatorPageSlice";
import YearlyArtifactDocumentComponent from "../Components/YearlyArtifactDocumentComponent";
import Footer from "../Components/Footer";
import ApproverHistoryTable from "../YealryReview/ApproverHistoryTable";
import useThemeRender from "../../../theme/useThemeRender";
import { showErrorToast, showSuccessToast } from "../../../utils/Toast/toast";
import DOMPurify from "dompurify";
import {
  getSelectedPendingApprovalData,
  getSelectedArtificatsHitoryData,
  getSelectedYearlyApprovalData,
  submitPendingApprovalRequest,
  submitYearyPendingApprovalRequest,
  denyPendingApprovalRequest,
  archiveYearlyPendingApprovalRequest,
  deleteCuratorFile,
  uploadYearlyReviewArtificatsFiles,
  getSMELookupData,
  getAllSubjectSectorCountryList,
  getFileDetail,
} from "../../../API/curatorApi";
import {
  uploadThumbnailAndGiveFileId,
  validateThumbnailAspectRatioFromUrl,
  validateThumbnailAspectRatio,
} from "../../../utils/function";
import {
  getDropDownOptionValues,
  getFormattedDate,
  getDisclaimerDetailsFromId,
  getCountryList,
  openItem,
  getLanguageNameById,
} from "../../../utils/function";
import Loading from "../../../utils/Loader";
import { CURATOR_PAGE_API_CONSTANT } from "../../../constant/constant";
import CommonModal from "../../../utils/CommonModal/CommonModal";
import fetchAndCacheImageName from "../../../utils/fetchAndCatchImageName";
import axios from "../../../API/API";
import { FILE_SERVICE_BASE_URL } from "../../../constant/apiUrl";
import useThumbnailUpload from "../../../hooks/useThumbnailUpload";
import SubtitleManagement from "../../SubtitleManagement/SubtitleManagement";
import ChapterManagement from "../../ChapterManagement/ChapterManagement";
import dayjs from "dayjs";

// Empty state for the "uploaded but not saved yet" trackers below.
const emptyPendingDocument = () => ({ file: null, fileId: null });
const emptyPendingThumbnail = () => ({ file: null, fileId: null, cdnUrl: null });

// Positions within the files[] pair handed to uploadArtificatsFiles.
const DOCUMENT_INDEX = 0;
const THUMBNAIL_INDEX = 1;

const createCanceledError = () => {
  const canceled = new Error("Upload canceled");
  canceled.canceled = true;
  return canceled;
};

// A cancel reaches us in several shapes depending on the browser and on which layer
// noticed it first, so every check goes through here.
const isCanceledError = (error, signal) =>
  !!signal?.aborted ||
  !!error?.canceled ||
  error?.code === "ERR_CANCELED" ||
  error?.name === "CanceledError" ||
  error?.name === "AbortError";

// Uploads one thumbnail. Lives outside the component because it needs nothing from it
// beyond the file, an abort signal and somewhere to report progress.
const uploadThumbnailWithProgress = async ({ file, signal, onProgress }) => {
  // Validate first, so a validation failure rejects the promise as-is.
  await validateThumbnailAspectRatio(file);
  // The upload may already have been canceled while validation was still running.
  if (signal.aborted) {
    throw createCanceledError();
  }

  const formData = new FormData();
  formData.append("file", file);

  let response;
  try {
    response = await axios.post(
      `${FILE_SERVICE_BASE_URL}/fritolay/file-manager/thumbnail/upload`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        signal,
        onUploadProgress: (event) => {
          if (signal.aborted) return;
          if (event.total) {
            onProgress(Math.round((event.loaded / event.total) * 100));
          }
        },
      }
    );
  } catch (error) {
    if (isCanceledError(error, signal)) {
      throw createCanceledError();
    }
    throw error;
  }

  if (response.status !== 200) {
    throw new Error("Thumbnail - Failed to upload thumbnail");
  }

  return {
    data: {
      fileId: response.data.fileId,
      fileLocation: response.data.fileLocation,
    },
    status: 200,
  };
};

const ArtificatPage = ({ pageName }) => {
  const { register, formState } = useForm({
    defaultValues: {
      contentTitle: "",
      specialProject: "",
      versionNumber: "",
    },
  });
  const { errors } = formState;
  const navigate = useNavigate();
  const queryParams = useParams();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width: 600px)");

  const { flagUser } = useSelector((store) => store.user);

  const [showAddMoreArtificats, setShowAddMoreArtificats] = useState(false);
  const editorRef = useRef(null);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [contentType, setContentType] = useState(null);
  const [countryData, setCountryData] = useState([]);
  const [secotrByCountrylist, setSectorByCountryList] = useState([]);
  const [explanation, setExplanation] = useState("");
  const [isArchiveType, setIsArchiveType] = useState(false);
  const [contentId, setContentId] = useState(null);
  const [subjectExpert, setSubjectExpert] = useState([]);
  const curatorPageLookUpData = useSelector((store) => store?.internalFilter);

  const [contentDetailsSectionData, setContentDetailsSectionData] = useState({
    contentTitle: "",
    visibility: "",
    contentLevel: "",
    specialProjects: [],
    subjects: [],
    sectors: [],
    countries: [],
    language: "",
    subjectMatterExpert: [],
    publicationDate: null,
  });
  const [cropTypeSectionData, setCropTypeData] = useState({
    keyWordsText: "",
    cropType: "",
  });
  const [approvalSection, setApprovalSection] = useState({
    legalApproval: null,
    dropImage: null,
    uploadedImageId: null,
    fileName: "",
    islegalFiledId: null,
  });
  const [summarySectionData, setSummarySectionData] = useState({
    documentNotes: "",
    summary: "",
    disclaimerDetails: "",
    isTranslation: false,
    translationLanguage: "",
    translatedText: "",
    disclaimer: "",
    languageId: 0,
  });
  const [artifactManagementArray, setArtifactManagementArray] = useState([
    artifactManagementData,
  ]);
  const [subtitleData, setSubtitleData] = useState([]);
  const [chapterManagementArray, setChapterManagementArray] = useState([]);
  const [approvarHistory, setApprovarHistory] = useState([]);
  const [documentUploadPct, setDocumentUploadPct] = useState(null);
  const [thumbnailUploadPct, setThumbnailUploadPct] = useState(null);
  // Derived, not its own state — so canceling just one file can't leave this stuck.
  const isArtifactUploading = documentUploadPct !== null || thumbnailUploadPct !== null;
  const docUploadAbortControllerRef = useRef(null);
  const thumbUploadAbortControllerRef = useRef(null);
  // A file that finished uploading but whose artifact hasn't been saved yet. The fileId
  // lets a later cancel/delete clean up the blob, and the file it came from lets the same
  // pick be reused instead of uploaded a second time.
  const pendingDocumentRef = useRef(emptyPendingDocument());
  const pendingThumbnailRef = useRef(emptyPendingThumbnail());
  const [videoChaptersFileDetails, setVideoChaptersFileDetails] = useState([]);
  const [videoSubtitlesFileDetails, setVideoSubtitlesFileDetails] = useState(
    []
  );
  const textColorLayer2 = useThemeRender("textColorLayer2");
  const cardBackgroundColor = useThemeRender("cardBackgroundColorLayer1");

  // Use the common thumbnail upload hook
  const { uploadThumbnail, isUploading: isThumbnailUploading } =
    useThumbnailUpload({
      validateAspectRatio: true,
      showSuccessMessage: false, // We'll show custom message
      showErrorMessage: true,
    });
  const selectFunctions = (pageName) => {
    switch (pageName) {
      case CURATOR_PAGE_API_CONSTANT.pending_approval:
        return {
          get: getSelectedPendingApprovalData,
          submit: submitPendingApprovalRequest,
          deny: denyPendingApprovalRequest,
          onConfirmLabel: "Approve",
          onCancelLabel: "Decline",
          backToLabel: "Back to pending approvals",
        };
      case CURATOR_PAGE_API_CONSTANT.artificat_history:
        return {
          get: getSelectedArtificatsHitoryData,
          submit: submitYearyPendingApprovalRequest,
          deny: () => {},
          onConfirmLabel: "Save",
          onCancelLabel: "Cancel",
          backToLabel: "Back to artifact history",
        };
      case CURATOR_PAGE_API_CONSTANT.yearly_review:
        return {
          get: getSelectedYearlyApprovalData,
          submit: submitYearyPendingApprovalRequest,
          deny: archiveYearlyPendingApprovalRequest,
          onConfirmLabel: "Confirm yearly review",
          onCancelLabel: "Archive",
          backToLabel: "Back to yearly review",
        };

      default:
        break;
    }
  };
  const { get, submit, deny, onConfirmLabel, onCancelLabel, backToLabel } =
    selectFunctions(pageName);

  useEffect(() => {
    getSMELookupData()
      .then((response) => {
        const smeData = getDropDownOptionValues(response, true);
        setSubjectExpert(smeData);

        getContentData(smeData);
      })
      .catch((error) => {
        console.log("failed to fetch sme data", error?.message);
        getContentData([]);
      });
  }, [curatorPageLookUpData?.sectorFilter]);

  useEffect(() => {
    if (
      countryData.length === 0 &&
      contentDetailsSectionData?.sectors?.length > 0 &&
      secotrByCountrylist?.length > 0
    ) {
      const countryList = getCountryList(
        contentDetailsSectionData?.sectors,
        secotrByCountrylist
      );

      setCountryData(getDropDownOptionValues(countryList, true));
    }
  }, [secotrByCountrylist]);

  useEffect(() => {
    const fetchLegalFile = async () => {
      if (
        approvalSection?.islegalFiledId !== null &&
        approvalSection?.islegalFiledId !== undefined
      ) {
        const data = await fetchAndCacheImageName(
          approvalSection.islegalFiledId
        );

        setApprovalSection((prevstate) => {
          return {
            ...prevstate,
            fileName: data?.name,
          };
        });
      }
    };
    fetchLegalFile();
  }, [approvalSection.islegalFiledId]);

  // Function to fetch file details for video chapters and subtitles
  const fetchFileDetails = async (fileIds, type) => {
    if (!fileIds || !Array.isArray(fileIds) || fileIds.length === 0) {
      return [];
    }

    try {
      const fileDetailPromises = fileIds.map(async (item) => {
        if (!item?.fileId) {
          console.warn(`Missing fileId for ${type} item:`, item);
          return null;
        }

        const fileDetail = await getFileDetail(item.fileId, false);
        return {
          ...item,
          fileDetail: fileDetail || null,
        };
      });

      const results = await Promise.all(fileDetailPromises);
      return results.filter((result) => result !== null);
    } catch (error) {
      console.error(`Error fetching file details for ${type}:`, error);
      showErrorToast(`Failed to fetch file details for ${type}`);
      return [];
    }
  };

  const getContentData = (smeData = []) => {
    get(queryParams?.id)
      .then(async (response) => {
        setContentType(response?.type);
        setContentDetailsSectionData({
          contentTitle: response?.title,
          visibility: response?.visibility,
          contentLevel: response?.level,
          specialProjects: response?.specialProjects,
          subjects: response?.subject,
          sectors: response?.sector,
          countries: response?.country,
          varieties: response?.variety,
          fleshColor: response?.fleshColor,
          ipOwnerShip: response?.ipOwnerShip,
          language: response?.language ?? "",
          subjectMatterExpert: response?.sme ?? [],
          publicationDate: response?.publicationDate
            ? dayjs(response.publicationDate).toISOString()
            : null,
        });
        setCropTypeData({
          keyWordsText: response?.keywords,
          cropType: response?.cropType,
        });
        setApprovalSection({
          legalApproval: response?.isLegalReview,
          dropImage: response?.document,
          fileName: "",
          islegalFiledId: response?.legalReviewFileId,
        });
        setSummarySectionData({
          documentNotes: response?.documentNotes,
          summary: response?.summary,
          disclaimerDetails: response?.disclaimerDetails,
          translatedText: response?.translationContent,
          translationLanguage: response?.translationLanguage,
          disclaimer: response?.disclaimer,
          isTranslation: response?.translationLanguage,
          languageId: response?.language,
        });
        setArtifactManagementArray(response?.artifactList);
        setContentId(response?.contentId);
        setApprovarHistory(response?.approverHistoryList);

        const isVideoContent = response?.type === "VIDEO";
        const normalizeToApiFormat = (items) => {
          if (!Array.isArray(items)) return [];
          return items
            .map((item) => ({
              fileId: item?.fileId,
              languageId: item?.languageId,
            }))
            .filter((item) => item.fileId && item.languageId);
        };

        if (
          isVideoContent &&
          response?.videoSubtitles &&
          Array.isArray(response.videoSubtitles)
        ) {
          setSubtitleData(normalizeToApiFormat(response.videoSubtitles));
        } else if (response?.subtitles && Array.isArray(response.subtitles)) {
          setSubtitleData(normalizeToApiFormat(response.subtitles));
        }

        // Load existing chapter data if available
        if (
          isVideoContent &&
          response?.videoChapters &&
          Array.isArray(response.videoChapters)
        ) {
          setChapterManagementArray(
            normalizeToApiFormat(response.videoChapters)
          );
        } else if (response?.chapters && Array.isArray(response.chapters)) {
          setChapterManagementArray(normalizeToApiFormat(response.chapters));
        }

        // Fetch file details for video chapters and subtitles
        if (response?.videoChapters && Array.isArray(response.videoChapters)) {
          const chaptersWithDetails = await fetchFileDetails(
            response.videoChapters,
            "videoChapters"
          );
          // setVideoChaptersFileDetails(chaptersWithDetails);

          // Map videoChaptersFileDetails to the expected structure for ChapterManagement
          const mappedChapters = await Promise.all(
            chaptersWithDetails.map(async (chapter, index) => {
              const languageName = await getLanguageNameById(
                chapter.languageId
              );
              return {
                id: Date.now() + index, // Generate unique ID
                file: {}, // Empty file object as per structure
                fileId: chapter.fileId,
                languageId: chapter.languageId,
                languageName: languageName,
                fileName:
                  chapter.fileDetail?.fileName || `Chapter_${chapter.fileId}`,
                fileSize: chapter.fileDetail?.fileSize || 0,
                displayName: chapter?.fileDetail?.displayName,
                uploadDate:
                  chapter.fileDetail?.createdDate || new Date().toISOString(),
              };
            })
          );
          setVideoChaptersFileDetails(mappedChapters);
        }

        if (
          response?.videoSubtitles &&
          Array.isArray(response.videoSubtitles)
        ) {
          const subtitlesWithDetails = await fetchFileDetails(
            response.videoSubtitles,
            "videoSubtitles"
          );
          // setVideoSubtitlesFileDetails(subtitlesWithDetails);

          // Map videoSubtitlesFileDetails to the expected structure for SubtitleManagement
          const mappedSubtitles = await Promise.all(
            subtitlesWithDetails.map(async (subtitle, index) => {
              const languageName = await getLanguageNameById(
                subtitle.languageId
              );

              return {
                id: Date.now() + index, // Generate unique ID
                file: {}, // Empty file object as per structure
                fileId: subtitle.fileId,
                languageId: subtitle.languageId,
                languageName: languageName,
                fileName:
                  subtitle.fileDetail?.fileName ||
                  `Subtitle_${subtitle.fileId}`,
                fileSize: subtitle.fileDetail?.fileSize || 0,
                displayName: subtitle?.fileDetail?.displayName,
                uploadDate:
                  subtitle.fileDetail?.createdDate || new Date().toISOString(),
              };
            })
          );
          setVideoSubtitlesFileDetails(mappedSubtitles);
        }

        getAllSubjectSectorCountryList()
          .then((data) => {
            setSectorByCountryList(data);
          })
          .catch((error) => {
            console.log("counry based on sector list error", error);
          });
        setIsPageLoading(false);
      })
      .catch((error) => {
        console.log("Get Approval API Error:", error?.message);
        showErrorToast("Get Approval API Error:", error?.message);
        setIsPageLoading(false);
      });
  };

  const uploadArtificatsFiles = async (files, newVersionNumber) => {
    let apiSuccessCount = 0;
    let fileData = {
      fileId: "",
      fileName: null,
    };
    let thumbnailData = {
      thumbnailFileId: "",
      cdnUrl: "",
    };
    if (contentType === "LINK") {
      fileData = {
        fileId: null,
        fileName: null,
        fileUrl: files[0]?.fileUrl,
      };
    }

    setDocumentUploadPct(contentType === "LINK" ? null : 0);
    setThumbnailUploadPct(0);
    // Deliberately not cleared here: a file left over from a cancelled attempt is what
    // lets this run reuse it instead of uploading the same bytes again. It gets cleared
    // once the artifact saves, or when that file is explicitly removed.
    const docAbortController = new AbortController();
    const thumbAbortController = new AbortController();
    docUploadAbortControllerRef.current = docAbortController;
    thumbUploadAbortControllerRef.current = thumbAbortController;

    const finishUpload = () => {
      setDocumentUploadPct(null);
      setThumbnailUploadPct(null);
      docUploadAbortControllerRef.current = null;
      thumbUploadAbortControllerRef.current = null;
    };

    // Picks how this half of the pair gets uploaded: reuse what a cancelled earlier
    // attempt already put on the server, or send it for real.
    const startUpload = (file, index) => {
      const pending =
        index === DOCUMENT_INDEX
          ? pendingDocumentRef.current
          : pendingThumbnailRef.current;

      // Same file object as last time means the bytes are already up there.
      if (pending.fileId && pending.file === file?.[0]) {
        return Promise.resolve({
          data: { fileId: pending.fileId, cdnUrl: pending.cdnUrl },
          status: 200,
          reused: true,
        });
      }

      if (index === THUMBNAIL_INDEX) {
        return uploadThumbnailWithProgress({
          file: file[0],
          signal: thumbAbortController.signal,
          onProgress: setThumbnailUploadPct,
        });
      }

      return uploadYearlyReviewArtificatsFiles(
        file,
        false,
        flagUser?.maxFileSize,
        {
          onProgress: (done, total) =>
            setDocumentUploadPct(total ? Math.round((done / total) * 100) : 0),
          signal: docAbortController.signal,
        }
      );
    };

    const recordDocumentResult = (response, file) => {
      if (!response?.reused) {
        showSuccessToast("File Upload Successfully");
      }
      fileData.fileId = response?.data?.fileId;
      fileData.fileName = file?.[0]?.name;
      // A cancel/delete from here on needs to delete this — it's a real saved blob now.
      pendingDocumentRef.current = {
        file: file?.[0],
        fileId: response?.data?.fileId,
      };
      // Clear its own progress bar rather than leaving it stuck at 100%.
      setDocumentUploadPct(null);
    };

    const recordThumbnailResult = async (response, file) => {
      if (!response?.reused) {
        showSuccessToast("Thumbnail uploaded successfully");
      }
      thumbnailData.thumbnailFileId = response?.data?.fileId;
      // Recorded before the CDN lookup below, so an abort mid-lookup still cleans up.
      pendingThumbnailRef.current = {
        file: file?.[0],
        fileId: response?.data?.fileId,
        cdnUrl: null,
      };
      setThumbnailUploadPct(null);

      if (response?.reused && response?.data?.cdnUrl) {
        thumbnailData.cdnUrl = response.data.cdnUrl;
      } else {
        // fileLocation isn't publicly accessible, so resolve a CDN url from the fileId.
        try {
          const thumbnailUrl = await fetchAndCacheImageName(
            response?.data?.fileId
          );
          if (thumbnailUrl?.url) {
            thumbnailData.cdnUrl = thumbnailUrl.url;
          }
        } catch (error) {
          console.error("Error fetching thumbnail URL:", error);
          // Continue even if thumbnail URL fetch fails
        }
      }
      pendingThumbnailRef.current.cdnUrl = thumbnailData.cdnUrl;
    };

    // Both halves are up: add the new version to the list and drop the pending state.
    const commitArtifactRow = () => {
      const updateTheArtificats = [...artifactManagementArray];
      updateTheArtificats.unshift({
        versionNumber: `${newVersionNumber}`,
        uploadedBy: `${flagUser?.firstName} ${flagUser?.lastName}`,
        uploadedDate: getFormattedDate(new Date()),
        isLocal: true,
        ...fileData,
        ...thumbnailData,
      });
      setArtifactManagementArray([...updateTheArtificats]);
      setShowAddMoreArtificats(false);
      pendingDocumentRef.current = emptyPendingDocument();
      pendingThumbnailRef.current = emptyPendingThumbnail();
      finishUpload();
    };

    const handleUploadFailure = (error) => {
      // A deliberate cancel already cleans up after itself in handleCancelArtifactUpload.
      if (isCanceledError(error)) {
        return;
      }
      console.log("error", error);
      // The aspect-ratio and thumbnail paths already showed a specific message.
      const errorMessage = error?.message || "";
      if (
        !errorMessage.includes("Thumbnail -") &&
        !errorMessage.includes("aspect ratio")
      ) {
        showErrorToast("Something went wrong in file upload");
      }
      // Don't leave the other upload running into a half-saved artifact.
      docAbortController.abort();
      thumbAbortController.abort();
      finishUpload();
    };

    files?.forEach((file, index) => {
      if (index === DOCUMENT_INDEX && contentType === "LINK") {
        apiSuccessCount++;
        return;
      }

      startUpload(file, index)
        .then(async (response) => {
          if (response?.error) {
            finishUpload();
            showErrorToast(response?.message);
            return;
          }
          apiSuccessCount++;

          if (index === DOCUMENT_INDEX) {
            recordDocumentResult(response, file);
          } else if (index === THUMBNAIL_INDEX) {
            await recordThumbnailResult(response, file);
          }

          if (apiSuccessCount === 2) {
            commitArtifactRow();
          }
        })
        .catch(handleUploadFailure);
    });
  };

  // Stops just the document upload, leaving an active thumbnail upload alone. The
  // thumbnail (if it already finished) is left in place — it gets reused instead of
  // re-uploaded if the document is saved again, instead of being deleted here.
  const abortDocumentUpload = () => {
    docUploadAbortControllerRef.current?.abort();
    docUploadAbortControllerRef.current = null;
    // Already saved server-side if it finished before the cancel — this file was
    // explicitly removed, so delete it.
    if (pendingDocumentRef.current.fileId) {
      deleteCuratorFile(pendingDocumentRef.current.fileId);
    }
    pendingDocumentRef.current = emptyPendingDocument();
    setDocumentUploadPct(null);
  };

  // Mirror of the above for the thumbnail.
  const abortThumbnailUpload = () => {
    thumbUploadAbortControllerRef.current?.abort();
    thumbUploadAbortControllerRef.current = null;
    if (pendingThumbnailRef.current.fileId) {
      deleteCuratorFile(pendingThumbnailRef.current.fileId);
    }
    pendingThumbnailRef.current = emptyPendingThumbnail();
    setThumbnailUploadPct(null);
  };

  // True while an upload is running, and also once a file has finished uploading but the
  // artifact hasn't been saved — that blob still needs cleaning up if the user leaves.
  const hasUnsavedUpload = () =>
    isArtifactUploading ||
    !!pendingDocumentRef.current.fileId ||
    !!pendingThumbnailRef.current.fileId;

  // Stops both uploads without closing the "Add more" panel.
  const abortPendingUpload = () => {
    abortDocumentUpload();
    abortThumbnailUpload();
  };

  // Full cancel: stop both uploads and close the panel — used by back navigation and the
  // page-level footer Cancel. The panel's own mid-upload Cancel button uses
  // abortPendingUpload instead, which stops the upload but leaves the panel open.
  const handleCancelArtifactUpload = () => {
    abortPendingUpload();
    setShowAddMoreArtificats(false);
  };

  const handleThumbnailReplace = async (file, artifactIndex) => {
    setIsPageLoading(true);

    const result = await uploadThumbnail(file);

    if (result) {
      // Update the artifact management array with new thumbnail
      const updatedArtifacts = [...artifactManagementArray];
      updatedArtifacts[artifactIndex] = {
        ...updatedArtifacts[artifactIndex],
        thumbnailFileId: result.fileId,
        cdnUrl: result.cdnUrl,
      };
      setArtifactManagementArray(updatedArtifacts);
      showSuccessToast("Thumbnail replaced successfully");
    }

    setIsPageLoading(false);
  };

  const uploadLegalDocuments = (file, isLegalDoc = false) => {
    setIsPageLoading(true);
    const fileDetails = file?.[0];
    uploadYearlyReviewArtificatsFiles(file, isLegalDoc, flagUser?.maxFileSize)
      .then((data) => {
        if (isLegalDoc) {
          setApprovalSection((prevState) => {
            return {
              ...prevState,
              uploadedImageId: data?.response?.fileId,
              fileName: fileDetails?.name,
              islegalFiledId: data?.data?.fileId,
            };
          });
        }
        if (data?.status === 200) {
          showSuccessToast("File uploaded Successfully");
        } else {
          showErrorToast("File upload failed");
        }
        setIsPageLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        showErrorToast("Something went wrong in file upload");
        setIsPageLoading(false);
      });
  };

  const deleteArtifcateFile = (file) => {
    setIsPageLoading(true);
    deleteCuratorFile(file)
      .then((data) => {
        showSuccessToast("File deleted Successfully");
        setApprovalSection({
          legalApproval: "",
          dropImage: "",
          fileName: "",
        });
        setIsPageLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        showErrorToast("Something went wrong in file upload");
        setIsPageLoading(false);
      });
  };

  const downloadFile = (fileId, contentUrl, navigate, params) => {
    setIsPageLoading(true);
    openItem(fileId, contentUrl, contentType)
      .then((value) => {
        showSuccessToast(value);
      })
      .catch((reason) => showErrorToast(reason))
      .finally(() => setIsPageLoading(false));
  };
  const onConfirm = {
    label: onConfirmLabel,
    handConfirmEvent: () => {
      setIsArchiveType(false);
      setIsModalVisible(true);
    },
  };

  const onCancel = {
    label: onCancelLabel,
    handleCancelEvent: () => {
      if (hasUnsavedUpload()) {
        handleCancelArtifactUpload();
      }
      if (pageName === CURATOR_PAGE_API_CONSTANT.artificat_history) {
        handleNavigation();
        return;
      }
      setIsArchiveType(true);
      setIsModalVisible(true);
    },
  };

  const checkRequiredNotFilled = () =>
    !contentDetailsSectionData?.contentTitle ||
    !contentDetailsSectionData?.visibility ||
    !contentDetailsSectionData?.fleshColor ||
    contentDetailsSectionData?.varieties.length === 0 ||
    !contentDetailsSectionData?.ipOwnerShip ||
    contentDetailsSectionData?.subjectMatterExpert.length === 0 ||
    !contentDetailsSectionData?.publicationDate;

  const approveCall = async (operationType) => {
    // Validate first entry image aspect ratio for artifact-history and pending approval pages
    // This validation MUST pass before proceeding with save
    if (
      (pageName === CURATOR_PAGE_API_CONSTANT.artificat_history ||
        pageName === CURATOR_PAGE_API_CONSTANT.pending_approval) &&
      operationType !== "deny"
    ) {
      if (!artifactManagementArray || artifactManagementArray.length === 0) {
        showErrorToast("Artifact management must have at least one entry.");
        return;
      }

      const firstEntry = artifactManagementArray[0];
      const imageUrl = firstEntry?.cdnUrl;
      const thumbnailFileId = firstEntry?.thumbnailFileId;

      // Skip validation if content type is LINK (no image)
      if (contentType === "LINK") {
        // LINK content type doesn't require image validation
      } else if (imageUrl || thumbnailFileId) {
        // Validate aspect ratio - this will block save if validation fails
        try {
          await validateThumbnailAspectRatioFromUrl(imageUrl, thumbnailFileId);
          // Validation passed, continue with save
        } catch (error) {
          // Validation failed - block save and show error
          showErrorToast(
            "Thumbnail - The artifact thumbnail must be in a 16:9 aspect ratio"
          );
          return; // Block save process
        }
      }
    }

    // Only proceed with save if validation passed (or validation not required)
    setIsModalVisible(false);
    setIsModalLoading(true);

    // Helper function to normalize data to only include fileId and languageId
    const normalizeToApiFormat = (items) => {
      if (!Array.isArray(items)) return [];
      return items
        .map((item) => ({
          fileId: item?.fileId,
          languageId: item?.languageId,
        }))
        .filter((item) => item.fileId && item.languageId);
    };

    let finalSubtitleData = normalizeToApiFormat(subtitleData || []);
    let finalChapterData = normalizeToApiFormat(chapterManagementArray || []);

    if (contentType === "VIDEO") {
      if (
        (!finalSubtitleData || finalSubtitleData.length === 0) &&
        videoSubtitlesFileDetails &&
        videoSubtitlesFileDetails.length > 0
      ) {
        finalSubtitleData = normalizeToApiFormat(videoSubtitlesFileDetails);
      }

      if (
        (!finalChapterData || finalChapterData.length === 0) &&
        videoChaptersFileDetails &&
        videoChaptersFileDetails.length > 0
      ) {
        finalChapterData = normalizeToApiFormat(videoChaptersFileDetails);
      }
    }

    const apiInputPayLoad = {
      contentId: contentId,
      contentGuid: queryParams?.id,
      title: contentDetailsSectionData?.contentTitle,
      visibility: contentDetailsSectionData?.visibility,
      specialProjects: contentDetailsSectionData?.specialProjects,
      subjects: contentDetailsSectionData?.subjects,
      sectors: contentDetailsSectionData?.sectors,
      countries: contentDetailsSectionData?.countries,
      language: contentDetailsSectionData?.language,
      subjectMatterExpert: contentDetailsSectionData?.subjectMatterExpert,
      contentLevel: contentDetailsSectionData?.contentLevel,
      fleshColor: contentDetailsSectionData?.fleshColor,
      variety: contentDetailsSectionData?.varieties,
      ipOwnerShip: contentDetailsSectionData?.ipOwnerShip,
      cropType: cropTypeSectionData?.cropType,
      keywords: cropTypeSectionData?.keyWordsText,
      legalReview: approvalSection?.legalApproval,
      document: "",
      documentNotes: DOMPurify.sanitize(
        summarySectionData?.documentNotes ?? "",
        {
          ALLOWED_TAGS: [],
        }
      ),
      originalFileId:
        approvalSection?.uploadedImageId === null ||
        approvalSection?.uploadedImageId === undefined
          ? null
          : approvalSection?.uploadedImageId,
      summary: DOMPurify.sanitize(summarySectionData?.summary ?? "", {
        ALLOWED_TAGS: [],
      }),
      legalReviewFileId:
        approvalSection?.islegalFiledId === null ||
        approvalSection?.islegalFiledId === undefined
          ? null
          : approvalSection?.islegalFiledId,

      disclaimer: summarySectionData?.disclaimer,
      disclaimerDetail: summarySectionData?.disclaimerDetails,
      isTranslation: !!summarySectionData?.isTranslation,
      translationLanguageId: summarySectionData?.languageId ?? null,
      rejectedExplanation: explanation,
      translatedText: summarySectionData?.translatedText,
      reviewedBy: `${flagUser?.FirstName} ${flagUser?.LastName}`,
      artifactManagementList: artifactManagementArray,
      subtitles: finalSubtitleData,
      chapters: finalChapterData,
      videoSubtitles: finalSubtitleData,
      videoChapters: finalChapterData,
      publicationDate: contentDetailsSectionData?.publicationDate
        ? dayjs(contentDetailsSectionData.publicationDate).format(
            "YYYY-MM-DDTHH:mm:ss.SSS"
          )
        : null,
    };

    const notificationTitle = apiInputPayLoad?.title ?? "Content";
    if (operationType === "deny") {
      apiInputPayLoad.rejectedExplanation = explanation;
      deny(apiInputPayLoad)
        .then((response) => {
          if (response?.status !== 200) {
            setIsModalLoading(false);
            showErrorToast(
              `Opps! Something went wrong:${response?.data?.message}`
            );
          } else {
            showSuccessToast(`${notificationTitle} denied successfully!`);
            navigate("/curator");
            setExplanation("");
          }
        })
        .catch((error) => {
          showErrorToast(`Opps! Something went wrong:${error?.message}`);
        })
        .finally(() => {
          setIsPageLoading(false);
          setIsModalLoading(false);
          setIsModalVisible(true);
        });
    } else {
      if (checkRequiredNotFilled()) {
        setIsModalLoading(false);
        showErrorToast("Please fill all required fields");
        return;
      }
      submit(apiInputPayLoad)
        .then((response) => {
          if (response?.status !== 200) {
            setIsModalLoading(false);
            showErrorToast(`Opps! Something went wrong:${response?.message}`);
          } else {
            showSuccessToast(`${notificationTitle}  published successfully!`);
            dispatch(setSelectedCuratorPage("Artifact history"));
            navigate("/curator");
          }
        })
        .catch((error) => {
          showErrorToast(`Opps! Something went wrong:${error?.message}`);
        })
        .finally(() => {
          setIsPageLoading(false);
          setIsModalLoading(false);
          setIsModalVisible(true);
        });
    }
  };

  const handleNavigation = () => {
    // Leaving the page mid-upload would strand an in-flight document/thumbnail PATCH
    // with nothing left to receive its progress updates — cancel it first.
    if (hasUnsavedUpload()) {
      handleCancelArtifactUpload();
    }
    navigate("/curator");
  };
  const handleClose = () => {
    setIsModalVisible(false);
  };

  const handleArtifactManagement = () => {
    setShowAddMoreArtificats(true);
  };

  return (
    <Container>
      <Body>
        <BackToFunction label={backToLabel} handleBack={handleNavigation} />
        {isPageLoading && <Loading />}
        <CardWrapper
          sx={{ background: useThemeRender("cardBackgroundColorLayer1") }}
        >
          <ContentDetails
            errors={errors}
            register={register}
            setContentDetailsSectionData={setContentDetailsSectionData}
            contentDetailsSectionData={contentDetailsSectionData}
            lookUpOptions={curatorPageLookUpData}
            countryData={countryData}
            setCountryData={setCountryData}
            subjectExpert={subjectExpert}
            secotrByCountrylist={secotrByCountrylist}
            pageName={pageName}
          />

          <CropType
            cropTypeSectionData={cropTypeSectionData}
            setCropTypeData={setCropTypeData}
            cropTypeOptions={curatorPageLookUpData?.cropTypeFilter}
          />

          <Approval
            isDisabled={
              approvalSection?.legalApproval !== true &&
              approvalSection?.legalApproval !== 2
            }
            approvalSection={approvalSection}
            setApprovalSection={setApprovalSection}
            uploadArtificatsFiles={uploadLegalDocuments}
            deleteArtifcateFile={deleteArtifcateFile}
          />

          <SummarySection
            editorRef={editorRef}
            summarySectionData={summarySectionData}
            setSummarySectionData={setSummarySectionData}
            getDisclaimerDetailsFromId={getDisclaimerDetailsFromId}
            lookUpOptions={curatorPageLookUpData}
          />

          <HeaderBox isMobile={isMobile}>
            <HeaderTitle sx={{ color: textColorLayer2 }}>
              Artifact management
            </HeaderTitle>
            {pageName !== CURATOR_PAGE_API_CONSTANT.pending_approval && (
              <AddMoreButton
                variant="contained"
                isMobile={isMobile}
                onClick={handleArtifactManagement}
                disabled={showAddMoreArtificats}
              >
                Add more
                <PlusIcon />
              </AddMoreButton>
            )}
          </HeaderBox>

          {showAddMoreArtificats && (
            <YearlyArtifactDocumentComponent
              register={register}
              onSave={uploadArtificatsFiles}
              showAddMoreArtificats={setShowAddMoreArtificats}
              artifactManagementArray={artifactManagementArray}
              contentType={contentType}
              isUploading={isArtifactUploading}
              documentUploadPct={documentUploadPct}
              thumbnailUploadPct={thumbnailUploadPct}
              onCancelUpload={abortPendingUpload}
              onAbortDocumentUpload={abortDocumentUpload}
              onAbortThumbnailUpload={abortThumbnailUpload}
            />
          )}

          <ArtifactManagement
            register={register}
            artifactManagementArray={artifactManagementArray}
            setArtifactManagementArray={setArtifactManagementArray}
            contentId={contentId}
            downloadFile={downloadFile}
            contentType={contentType}
            pageName={pageName}
            onThumbnailReplace={handleThumbnailReplace}
          />
          {contentType === "VIDEO" && (
            <>
              <SubtitleManagement
                subtitleData={subtitleData}
                setSubtitleData={setSubtitleData}
                videoSubtitlesFileDetails={videoSubtitlesFileDetails}
                setVideoSubtitlesFileDetails={setVideoSubtitlesFileDetails}
                contentId={contentId}
                downloadFile={downloadFile}
                contentType={contentType}
              />
              <ChapterManagement
                chapters={chapterManagementArray}
                videoChaptersFileDetails={videoChaptersFileDetails}
                setVideoChaptersFileDetails={setVideoChaptersFileDetails}
                setChapters={setChapterManagementArray}
                contentType={contentType}
              />
            </>
          )}

          {pageName !== CURATOR_PAGE_API_CONSTANT.pending_approval && (
            <>
              <HeaderBox isMobile={isMobile}>
                <HeaderTitle sx={{ color: textColorLayer2 }}>
                  Approver history
                </HeaderTitle>
              </HeaderBox>
              <ApproverHistoryTable apprverHistory={approvarHistory} />
            </>
          )}
        </CardWrapper>
      </Body>

      <Footer
        onCancel={onCancel}
        onConfirm={onConfirm}
        disabled={isArtifactUploading}
        btnStyle={{
          ...(pageName === CURATOR_PAGE_API_CONSTANT.pending_approval
            ? { background: "#D40020" }
            : {
                color: "#005CBC",
                border: "1px solid var(--Tokens-Button-Outlined, #005CBC)",
              }),
          flex: isMobile && 1,
        }}
      />

      <CommonModal
        approveModal={isModalVisible}
        isDeny={isArchiveType}
        denyhandler={approveCall}
        explanation={explanation}
        setExplanation={setExplanation}
        showIcon={true}
        handleClose={handleClose}
        loading={isModalLoading}
      />
    </Container>
  );
};

export default ArtificatPage;
